import React, { forwardRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  selectSingleElement,
  selectMultipleElements,
  setKeyElement,
  deleteText,
  verifyElementsLoaded,
  validateElement,
  validateDesign
} from "../../../../../../actions";
import DeleteElementButton from "../DeleteElementButton";
import TextImage from "./TextImage";

const Text = forwardRef((props, ref) => {
  const onHandleClick = (event) => {
    // Return if layers are disabled so element can't be selected
    if (props.disableInteractivity) {
      return false;
    }

    const id = props.textElement.id,
      value = !props.textElement.is_selected;

    if (event.shiftKey) {
      // Shift click to select multiple elements
      handleSelectMultipleElements(id, value);
    } else {
      // Regular click to select single element
      handleSelectSingleElement(id, value);
    }
  };

  const handleSelectSingleElement = (id, value) => {
    props.selectSingleElement({
      id,
      value,
      index: props.index,
      layerId: props.layerId,
      itemType: props.itemType
    });

    if (!props.didShow2ndTip) {
      props.onShow2ndTip();
    }
  };

  const handleSelectMultipleElements = (id, value) => {
    props.selectMultipleElements({
      id,
      value,
      index: props.index,
      layerId: props.layerId,
      itemType: props.itemType
    });

    if (!props.didShow2ndTip) {
      props.onShow2ndTip();
    }
  };

  const onDeleteText = () => {
    const id = props.textElement.id;
    props.deleteText({
      id,
      index: props.index,
      layerId: props.layerId
    });
    props.validateDesign();
  };

  const componentDidUpdate = (prevProps) => {
    if (
      prevProps.textElement.width !== props.textElement.width ||
      prevProps.textElement.height !== props.textElement.height
    ) {
      if (props.textElement.width && props.textElement.height) {
        props.validateElement({
          index: props.index,
          layerId: props.layerId,
          itemType: props.itemType
        });
      }
    }
  };

  const selected = props.textElement.is_selected ? "selected" : "",
    selectDisabled = props.disableInteractivity ? "disabled" : "";

  return (
    <div
      className={`text-element-wrapper ${selected} ${selectDisabled}`}
      onClick={onHandleClick}
      ref={ref}
    >
      {props.textElement.is_selected && !props.disableInteractivity && (
        <DeleteElementButton onDelete={onDeleteText} />
      )}
      <TextImage
        url={props.url}
        onVerifyElementLoaded={props.verifyElementsLoaded}
        anchor_point={props.textElement.anchor_point}
        domNodeWidth={
          props.textElement.width * (props.design.preview_scale * 72)
        }
      />
    </div>
  );
});

Text.displayName = "Text";

function mapStateToProps(state, ownProps) {
  return {
    design: state.design.present
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      selectSingleElement,
      selectMultipleElements,
      setKeyElement,
      deleteText,
      verifyElementsLoaded,
      validateElement,
      validateDesign
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true
})(Text);
